export default "__VITE_ASSET__CtYMo5MK__"